import { render } from "./faceDetection.vue?vue&type=template&id=1f5ecc13"
import script from "./faceDetection.vue?vue&type=script&lang=js"
export * from "./faceDetection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__